{
  "RRSP": "REER",
  "TFSA": "CELI",
  "PERSONAL": "Trésorerie",
  "RESP": "REEE",
  "RESP_SINGLE": "REEE individuel",
  "RESP_FAMILY": "REEE familial",
  "RESP_ADULT": "REEE pour adulte",
  "CORPORATE_CASH": "Trésorerie d'entreprise",
  "CORPORATE_TRUST": "Fiducies",
  "CORPORATE_ESTATE": "Succession d'entreprise",
  "CORPORATE_CHARITY": "Philanthropie d'entreprise",
  "RRSP_SPOUSAL": "REER conjoint",
  "LIRA": "CRI",
  "RRIF": "FERR",
  "RIF_SPOUSAL": "FERR conjoint",
  "LIF": "FRV",
  "PRIF": "FERR prescrit",
  "GRSP": "RERC",
  "CASH_JOINT": "Trésorerie conjointe",
  "RDSP": "REEI",
  "RDSP_JOINT": "REEI conjoint",
  "MARGIN": "Marge",
  "MARGIN_JOINT": "Joint de marge",
  "RESP_SINGLE_JOINT": "REEE conjoint individuel",
  "RESP_FAMILY_JOINT": "REEE conjoint familial",
  "INFORMAL_TRUST": "Fiducie informelle",
  "INFORMAL_TRUST_JOINT": "Fiducie informelle conjointe",
  "FHSA": "CELIAPP",
  "RLSP": "REIR",
  "LRSP": "RERI",
  "RLIF": "FRVR",
  "LRIF": "FRRI",
  "DBPP": "RRPD",
  "IPP": "RRI",
  "RPP": "RRA",
  "USA_BROKERAGE": "Compte de courtage individuel/Compte espèces",
  "USA_IRA": "PER traditionnel",
  "USA_RO_IRA": "PER renouvelable",
  "USA_RT_IRA": "PER exonéré d'impôt",
  "USA_INH_IRA": "PER hérité",
  "USA_INH_RT_IRA": "PER exonéré d'impôt hérité",
  "USA_JT_WROS": "Lois sur les copropriétaires avec gain de survie (JTWROS)",
  "USA_JT_JTBE": "Copropriétaires en pleine propriété",
  "USA_JT_TIC": "Copropriétaire avec gain de survie (TIC)",
  "USA_JT_CP": "Copropriétaire avec gain de survie (CP)",
  "USA_SEP_IRA": "PER de retraite des employés simplifié",
  "USA_401K": "401(k) parrainé par l'employeur",
  "USA_SOLO_401K": "401(k) seul",
  "USA_TRUST": "Compte en fiducie",
  "USA_CORPORATE": "Compte social/comptes sociaux",
  "USA_ESA": "Compte d'épargne pour les études",
  "USA_529": "Régime d'épargne 529",
  "UK_BROKERAGE": "Compte général",
  "UK_CASH_ISA": "Compte d'épargne individuel, espèces",
  "UK_SS_ISA": "Compte d'épargne individuel, actions",
  "UK_JISA": "Compte d'épargne individuel, junior",
  "UK_PERSONAL_PENSION": "Pension personnelle",
  "USA_TOD": "Courtage individuel - Transfert consécutif au décès",
  "USA_ESTATE": "Succession",
  "USA_DAF": "Fonds conseillé par le donateur",
  "USA_SIMPLE_IRA": "PER SIMPLE",
  "USA_KEOGH": "Plan Keogh / HR-10",
  "USA_CUSTODIAL": "Compte de dépôt",
  "USA_IRA_CUSTODIAL": "PER (mineur) de dépôt",
  "USA_DBP": "Régime de prévoyance défini",
  "USA_CRA": "Compte de retraite d'entreprise / caisse de retraite en fiducie",
  "USA_MARGIN": "Compte sur marge individuel",
  "USA_JT_WROS_MARGIN": "Compte sur marge copropriétaire avec gain de survie (JTWROS)",
  "USA_JT_TIC_MARGIN": "Compte sur marge copropriétaire avec gain de survie (TIC)",
  "USA_JT_JTBE_MARGIN": "Compte sur marge copropriétaires en pleine propriété",
  "USA_JT_CP_MARGIN": "Compte sur marge copropriétaire avec gain de survie (CP)",
  "EXTERNAL": "Externe",
  "INVESTMENT": "Placement",
  "PENSION_PLAN": "Régime de retraite"
}
